import { useContext } from 'react';
import { PaymentFlowContext } from '../../providers/PaymentFlowProvider';

export default function usePaymentFlow() {
  return useContext(PaymentFlowContext);
}
